
const BADGES = {
  strongest: {
    icon: ['fas', 'bolt'],
    label: 'components.vehicleBulbBadge.strongest',
    hint: null,
    dark: 'tw-bg-[#ffa41c]/15 tw-text-[#ffa41c]',
    solid: 'tw-bg-[#ffa41c] tw-text-[#0d1016] tw-shadow',
  },
  best_value: {
    icon: ['fas', 'coins'],
    label: 'components.vehicleBulbBadge.bestValue',
    hint: 'components.vehicleBulbBadge.bestValueHint',
    dark: 'tw-bg-[#38bdf8]/15 tw-text-[#7dd3fc]',
    solid: 'tw-bg-[#0369a1] tw-text-white tw-shadow',
  },
}

export default {
  name: 'VehicleBulbBadge',
  props: {
    badge: {
      type: String,
      required: true,
      validator: value => Object.keys(BADGES).includes(value),
    },
    solid: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    config() {
      return BADGES[this.badge]
    },
    icon() {
      return this.config.icon
    },
    label() {
      return this.$t(this.config.label)
    },
    hint() {
      return this.config.hint ? this.$t(this.config.hint) : null
    },
    toneClass() {
      return this.solid ? this.config.solid : this.config.dark
    },
    tooltip() {
      return {
        title: this.hint || '',
        disabled: !this.hint,
        placement: 'top',
      }
    },
  },
}
